export class ServiceCodesScanRequest {
    constructor( 
        public ClinicID?: string,
        public LocationID?: string,
        public EquipmentID?: string,
        public MachineName?: string,
        public Severity?: string,
        public ErrorLevel?: string,
        public FromDate?: Date,
        public ToDate?: Date,
        public ServiceCodesScanFilters?: ServiceCodesScanFilters
    ) {}
}

export class ServiceCodesScanReportData {
    constructor( 
        public ServiceCodesScanReportList?: Array<ServiceCodesScanReport>,
        public ServiceCodesScanFilters?: ServiceCodesScanFilters
    ) {}
}

export class ServiceCodesScanReport {
    constructor( 
        public ClinicID?: string,
        public ClinicName?: string,
        public LocationID?: string,
        public LocationName?: string,
        public EquipmentID?: string,
        public EquipmentShortName?: string,
        public MachineID?: string,
        public MachineName?: string,
        public MacAddress?: string,
        public LogMessage?: string,
        public Severity?: string,
        public ErrorLevel?: string,
        public FirmwareVersion?: string,
        public LogDateTime?: Date
    ) {}
}

export class ServiceCodesScanFilters {
    constructor( 
        public ClinicName?: string,
        public LocationName?: string,
        public Equipment?: string,
        public MachineName?: string,
        public Severity?: string,
        public ErrorLevel?: string,
        public FromDate?: Date,
        public ToDate?: Date
    ) {}
}